<template>
  <a-modal
    title="新建名片"
    :width="800"
    :visible="visible"
    :confirmLoading="loading"
    @ok="ok"
    @cancel="cancel"
    :destroyOnClose="true"
    :maskClosable="false"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
        <a-form-item label="关联用户">
          <a-select
            show-search
            :filter-option="false"
            :not-found-content="fetching ? '搜索中...' : null"
            placeholder="请输入用户昵称搜索"
            v-decorator="['user_id', { rules: [{ required: true, message: '请选择关联用户' }] }]"
            :default-active-first-option="false"
            @search="handleUserSearch"
            @select="handleUserSelect"
          >
            <a-select-option v-for="d in userDataSource" :key="d.id" :value="d.id">
              {{ d.nickname }} (ID: {{ d.id }})
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="姓名">
          <a-input
            v-decorator="['name', { rules: [{ required: true, message: '请输入姓名' }] }]"
            placeholder="姓名"
          />
        </a-form-item>

        <a-form-item label="公司">
          <a-input
            v-decorator="['company']"
            placeholder="公司名称"
          />
        </a-form-item>

        <a-form-item label="职位">
          <a-input
            v-decorator="['position']"
            placeholder="职位"
          />
        </a-form-item>

        <a-form-item label="部门">
          <a-input
            v-decorator="['department']"
            placeholder="部门"
          />
        </a-form-item>

        <a-form-item label="手机">
          <a-input
            v-decorator="['phone']"
            placeholder="手机号码"
          />
        </a-form-item>

        <a-form-item label="邮箱">
          <a-input
            v-decorator="['email']"
            placeholder="邮箱"
          />
        </a-form-item>

        <a-form-item label="微信">
          <a-input
            v-decorator="['wechat']"
            placeholder="微信号"
          />
        </a-form-item>

        <a-form-item label="头像">
          <a-upload
            name="file"
            accept="image/png, image/jpeg, image/jpg"
            :action="actionUrl"
            list-type="picture-card"
            :file-list="fileList"
            :data="uploadParams"
            :before-upload="beforeUpload"
            @change="handleAvatarChange"
            @preview="handlePreview"
          >
            <div v-if="fileList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">
                上传
              </div>
            </div>
          </a-upload>
          <a-modal :visible="previewVisible" :footer="null" @cancel="handlePreviewCancel">
            <img alt="预览" style="width: 100%" :src="previewImage" />
          </a-modal>
        </a-form-item>

        <a-form-item label="地址">
          <a-input
            v-decorator="['address']"
            placeholder="地址"
          />
        </a-form-item>

        <a-form-item label="经纬度">
          <a-row :gutter="8">
            <a-col :span="12">
              <a-input
                v-decorator="['latitude']"
                placeholder="纬度"
              />
            </a-col>
            <a-col :span="12">
              <a-input
                v-decorator="['longitude']"
                placeholder="经度"
              />
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import debounce from 'lodash/debounce'
import { user_list } from '@/api/user'
import { oss_token_list } from '@/api/oss_token'

export default {
  name: 'CardCreateForm',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.handleUserSearch = debounce(this.handleUserSearch, 800)
    return {
      form: this.$form.createForm(this),
      userDataSource: [],
      fetching: false,
      // OSS 上传相关
      actionUrl: '',
      uploadParams: {
        'key': '',
        'policy': '',
        'OSSAccessKeyId': '',
        'signature': ''
      },
      fileList: [],
      previewVisible: false,
      previewImage: '',
      avatarUrl: ''
    }
  },
  mounted () {
    // 获取 OSS token
    this.getOssToken()
  },
  methods: {
    // 获取 OSS 上传凭证
    getOssToken () {
      oss_token_list().then(({ data }) => {
        this.uploadParams.OSSAccessKeyId = data.accessid
        this.uploadParams.policy = data.policy
        this.uploadParams.signature = data.signature
        this.actionUrl = 'https://static2.jnzbtz.com'
      })
    },
    // 用户搜索
    handleUserSearch (value) {
      if (!value) {
        this.userDataSource = []
        return
      }
      this.fetching = true
      user_list({ nickname: value }).then((res) => {
        const result = res.data.entries || []
        this.userDataSource = result.length > 10 ? result.slice(0, 10) : result
        this.fetching = false
      }).catch(() => {
        this.fetching = false
      })
    },
    // 用户选择
    handleUserSelect (value) {
      // 用户选择时不自动填充姓名，让用户手动输入
    },
    // OSS 上传前校验
    beforeUpload (file) {
      const allows = ['image/jpeg', 'image/png', 'image/jpg']
      if (allows.indexOf(file.type) === -1) {
        this.$message.warning('只支持 jpg/png 格式的图片')
        return false
      }
      if (file.size / 1024 / 1024 > 5) {
        this.$message.warning('图片大小不能超过 5MB')
        return false
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      this.uploadParams.key = file.uid + '_' + file.lastModified + '.' + suffix
      return true
    },
    // 头像上传变更
    handleAvatarChange ({ file, fileList }) {
      this.fileList = fileList
      if (file.status === 'done') {
        const suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
        this.avatarUrl = this.actionUrl + '/' + file.uid + '_' + file.lastModified + '.' + suffix
        // 只保留新上传的头像
        this.fileList = [{
          uid: file.uid,
          name: file.name,
          status: 'done',
          url: this.avatarUrl
        }]
      }
      if (file.status === 'removed') {
        this.fileList = []
        this.avatarUrl = ''
      }
    },
    // 图片预览
    handlePreview (file) {
      this.previewImage = file.url || file.thumbUrl
      this.previewVisible = true
    },
    // 关闭预览
    handlePreviewCancel () {
      this.previewVisible = false
    },
    ok () {
      this.$emit('ok')
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
